import React, { Fragment, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Delete, NotificationImportant } from "@mui/icons-material";
import CustomTable from "../templates/CustomTable";
import { notificationHeader } from "../utils/HeaderData";
import { toast } from "react-toastify";
import {
  collection,
  getDocs,
  orderBy,
  query,
  writeBatch,
} from "firebase/firestore";
import { db } from "../firebase";
import { useUser } from "../components/context/UserContext";

const Notification = () => {
  const navigate = useNavigate();
  const { userRole, loading: roleLoading } = useUser();
  const [show, setShow] = useState(false);
  const [notifications, setNotifications] = useState([]);

  useEffect(() => {
    if (!roleLoading && userRole === "operator") {
      navigate("/home");
    }
  }, [roleLoading, userRole, navigate]);

  React.useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const q = query(collection(db, "notifications"), orderBy("createdAt", "desc"));
        const snap = await getDocs(q);
        setNotifications(
          snap.docs.map((d) => ({
            _id: d.id,
            ...d.data(),
            createdAt: d.data().createdAt?.toDate() || new Date(),
          }))
        );
      } catch (err) {
        console.error(err.message);
      }
    };
    fetchNotifications();
  }, []);

  const deleteAll = async () => {
    try {
      const snap = await getDocs(collection(db, "notifications"));
      const batch = writeBatch(db);
      snap.docs.forEach((d) => batch.delete(d.ref));
      await batch.commit();
      toast("All notifications cleared", { type: "info" });
      setShow(false);
      setTimeout(() => window.location.reload(), 1500);
    } catch (err) {
      console.error(err.message);
      toast("Error clearing notifications", { type: "error" });
    }
  };

  return (
    <Fragment>
      <div className="min-h-screen bg-[#f5f7fe] p-3 sm:p-6">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 sm:gap-0 mb-6">
            <div className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-xl bg-[#eef2ff] flex items-center justify-center flex-shrink-0">
                <NotificationImportant style={{ color: "#000C66", fontSize: 20 }} />
              </div>
              <div>
                <h1 className="text-xl sm:text-2xl font-bold text-[#000C66] font-aref">Notifications</h1>
                <p className="text-gray-400 text-xs font-abel">Admin activity log</p>
              </div>
            </div>
            <button
              onClick={() => setShow(true)}
              className="flex items-center justify-center gap-2 bg-red-500 text-white px-5 py-2.5 rounded-xl hover:bg-red-600 transition font-abel text-sm font-semibold w-full sm:w-auto"
            >
              <Delete style={{ fontSize: 18 }} /> Clear All
            </button>
          </div>

          <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
            <CustomTable
              headers={notificationHeader}
              data={notifications}
              editPath=""
              deletePath="/delete-notification"
            />
          </div>
        </div>
      </div>

      {show && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 backdrop-blur-sm">
          <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-sm w-full mx-4">
            <div className="text-center mb-6">
              <div className="w-14 h-14 rounded-full bg-red-50 flex items-center justify-center mx-auto mb-4">
                <Delete className="text-red-500" style={{ fontSize: 28 }} />
              </div>
              <h3 className="text-lg font-bold text-gray-900 font-aref">Clear All Notifications?</h3>
              <p className="text-red-400 text-xs font-abel mt-2">This action cannot be undone.</p>
            </div>
            <div className="flex gap-3">
              <button
                onClick={() => setShow(false)}
                className="flex-1 py-3 rounded-xl border border-gray-200 text-gray-700 font-abel font-medium hover:bg-gray-50 transition"
              >
                Cancel
              </button>
              <button
                onClick={deleteAll}
                className="flex-1 py-3 rounded-xl bg-red-500 text-white font-abel font-semibold hover:bg-red-600 transition"
              >
                Clear All
              </button>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
};

export default Notification;
